import { logService } from "@/service/index"
import { fillProperty } from "@/util/object"
import { applicationState } from "@/state"


export class IovationService {

    async load() {
        return new Promise(resolve => {
            globalThis.io_global_object_name = "IGLOO"

            globalThis.IGLOO = globalThis.IGLOO || {
                enable_flash: false,
                bb_callback: function (blackbox, complete) {
                    if (complete) {
                        logService.debug("updating device fingerprint with iovation blackbox")
                        fillProperty(applicationState.application, "device.fingerprint", blackbox, "fingerprint")
                        resolve(undefined)
                    }
                },
                loader: {
                    fp_dyn: false,
                    version: "general5",
                },
            }
            const globalIovationScript = document.createElement("script")
            globalIovationScript.setAttribute("src", `${process.env.BASE_URL}js/iovation-loader.js`)
            globalIovationScript.setAttribute("title", "globalIovationScript")
            document.head.appendChild(globalIovationScript)
        })
    }
}

export default IovationService

